import { FormattedHTMLMessage } from '@99designs/common/i18n';
import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import { Uploader } from '__generated__/Uploader';
import AttachmentUploader from 'common/components/uploader/AttachmentUploader';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    referenceFiles: StructuredBriefFile[];
}

interface Props<T> {
    form: ObservableForm<T>;
    uploader: Uploader;
}

export default function PacklaneFilesField<T extends Fields>(props: Props<T>) {
    const { form, uploader } = props;

    return (
        <Field
            form={form}
            name="referenceFiles"
            tooltip={__(
                'On Packlane.com; first choose your box style, navigate to design your box style, then Request dieline from the design tab'
            )}
            title={__('Add your Packlane dieline & reference files')}
            message={
                <>
                    <p>
                        <FormattedHTMLMessage
                            message={__(
                                'A dieline is the template for the specific Packlane package you’re creating. Go to <a {linkAttrs}>packlane.com</a> to download your dieline.'
                            )}
                            values={{ linkAttrs: `href=https://packlane.com target="__blank"` }}
                        />
                    </p>
                    <p>
                        {__(
                            'Also upload files such as your logo, photos, brand guide, fonts, copy, and any other documents.'
                        )}
                    </p>
                </>
            }
            render={() => (
                <AttachmentUploader uploader={uploader} {...form.attach('referenceFiles')} />
            )}
        />
    );
}
